// Tolgee bundle stems (the JSON filenames). Translations are authored per language, NOT per region:
// the app's canonical locale values are the full BCP-47 tags in `../index.ts` (en-US / fr-FR / fr-CA /
// nl-NL), which resolve onto these bundles via vue-i18n's `fallbackLocale` chain. `fr-CA` is an
// OPTIONAL Canada-overrides bundle — anything it does not translate falls back to `fr` (no duplication).
const BUNDLE_LOCALES = ["en", "fr", "fr-CA", "nl"];
function isBundleLocale(value) {
    return BUNDLE_LOCALES.includes(value);
}
function loadLocaleFiles() {
    // Vite/Vitest: `import.meta.glob` MUST appear as a literal expression.
    if (typeof import.meta.glob === "function") {
        const modules = import.meta.glob("./**/*.json", {
            eager: true,
        });
        return Object.entries(modules).map(([path, mod]) => [path, mod.default]);
    }
    // Webpack: `require.context(...)` MUST appear as a literal call.
    try {
        const ctx = require.context("./", true, /\.json$/);
        return ctx.keys().map((key) => [key, ctx(key)]);
    }
    catch {
        return [];
    }
}
function deepMerge(target, source) {
    for (const [key, value] of Object.entries(source)) {
        const existing = target[key];
        if (typeof value === "object" &&
            value !== null &&
            typeof existing === "object" &&
            existing !== null) {
            deepMerge(existing, value);
        }
        else {
            target[key] = value;
        }
    }
}
// Keyed by `string`, not `Record<BundleLocale, …>`, on purpose: the app's locale VALUES are
// the full BCP-47 tags in `../index.ts` (en-US / fr-FR / fr-CA / nl-NL), while these bundles are
// keyed by the 2-letter Tolgee stems. vue-i18n infers its locale-identifier type from `keyof
// messages`, so a `BundleLocale` key type would wrongly narrow `i18n.global.locale.value` to the
// stems and reject the full tags we actually assign. A `string` key keeps the locale identifier
// open (the full tags resolve onto these stems via the `fallbackLocale` chain); the `BundleLocale`
// seed keys below still type-check the writes, and `isBundleLocale` still gates the loader.
export const messages = {
    en: {},
    fr: {},
    "fr-CA": {},
    nl: {},
};
// The locale is the filename stem (last path segment before `.json`), so
// `./opublic.frontend/fr-CA.json` -> "fr-CA". Stems that aren't a supported
// locale are skipped. fr-CA bundles fall back to `fr` (then the fallback
// locale) for any key Tolgee has not translated for Canada specifically.
for (const [path, contents] of loadLocaleFiles()) {
    const match = path.match(/([^/]+)\.json$/);
    if (!match) {
        continue;
    }
    const locale = match[1];
    if (!isBundleLocale(locale)) {
        continue;
    }
    deepMerge(messages[locale], contents);
}
export { BUNDLE_LOCALES };
